import React from 'react';
import { TypographyProps } from '@mui/material/Typography';
import InternalLink from './InternalLink';

interface IProps {
  id: string
  name: React.ReactNode
  path: string
  title?: string
  color?: TypographyProps['color']
  variant?: TypographyProps['variant']
}

const ContactLink:React.FC<React.PropsWithChildren<IProps>> = ({ id, name, path, ...props }: IProps) => {
  return (
  <InternalLink
    {...props}
    to={`${path}/${id}`}
  >
    {name}
  </InternalLink>
  );
};

export default ContactLink;
